<template>
  <div class="pages information_sharing_list">
    <div class="container">
      <p><strong>熊猫绘画第三方信息共享清单</strong></p>
      <p>
        我们与合作方合作过程中，将遵守以下原则：<br />
        a) 合法原则：涉及数据处理活动的，应当遵守合法原则。<br />
        b)
        正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。<br />
        c) 安全审慎原则：
        我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
      </p>
      <p><strong>第三方SDK清单</strong></p>
      <table class="sdk-table">
        <thead>
          <tr>
            <th>SDK名称</th>
            <th>SDK所属公司</th>
            <th>用途</th>
            <th>读取的信息或需要您打开的权限</th>
            <th>收集方式</th>
            <th>第三方隐私政策链接</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>MobTech ShareSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>为用户提供社交分享、第三方登录社交分享、第三方登录服务</td>
            <td>
              网络权限、读写储存权限、获取手机信息权限、 系统运行信息、OPEN
              ID（第三方账号）、设备标识信息(OAID、IMSI)、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=638&amp;id=14"
                target="_blank"
                >《ShareSDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>MobTech SMSSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>短信验证功能</td>
            <td>
              网络权限、读写储存权限、获取手机信息权限、系统运行信息、手机号码、网络状态信息、设备标识信息(OAID、IMSI)、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=596&amp;id=23"
                target="_blank"
                >《SMSSDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>MobTech MobPushSDK</td>
            <td>上海掌之淘信息技术有限公司</td>
            <td>为您提供 消息推送服务</td>
            <td>
              网络权限、读写储存权限、系统运行信息、设备标识信息（OAID、IMSI）、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.mob.com/wiki/detailed?wiki=637&amp;id=136"
                target="_blank"
                >《MobPush隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>talkingdata</td>
            <td>北京腾云天下科技有限公司</td>
            <td>匿名统计分析</td>
            <td>
              网络权限、读写储存权限、获取手机信息权限、MAC地址、IMEI、
              IMSI、MEID、OAID、设备硬件序列号、Android
              ID、地理定位、BSSID、IP地址、SSID、运营商信息、应用进程列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.talkingdata.com/privacy.jsp?languagetype=zh_cn"
                target="_blank"
                >《talkingdata隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>小米推送</td>
            <td>小米科技有限公司</td>
            <td>推送消息</td>
            <td>
              网络权限、设备标识符（Android
              ID、OAID）、WLAN接入点（SSID）、设备信息（设备类型、操作系统）、网络信息（运营商类型、网络类型）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://dev.mi.com/console/doc/detail?pId=1822/"
                target="_blank"
                >《小米推送隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>OPPO 推送</td>
            <td>广东欢太科技有限公司</td>
            <td>推送消息</td>
            <td>
              网络权限、设备识别码（IMEI或OAID，DUID，OUID，GUID，ICCID，MEID，Serial
              Number，IMSI，User ID，Android
              ID，ClientID）、设备信息（设备型号、操作系统版本）、网络信息（运营商类型、网络类型）、推送SDK版本号、IP地址
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://open.oppomobile.com/wiki/doc#id=10288"
                target="_blank"
                >《OPPO开放平台隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>vivo 推送</td>
            <td>广东天宸网络科技有限公司及将来受让运营vivo开放平台的公司</td>
            <td>推送消息</td>
            <td>
              网络权限、设备及应用信息、设备标识符（IMEI、ICCID 、EMMCID/UFSID
              、OAID/VAID/AAID 、SN码 和 IMSI、Android id、移动国家码和vivo
              Android设备的移动网号）、MAC地址、日志信息、移动运营商、位置信息（WLAN热点/基站信息）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://dev.vivo.com.cn/documentCenter/doc/366"
                target="_blank"
                >《vivo开放平台服务协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>华为推送</td>
            <td>华为软件技术有限公司</td>
            <td>推送消息</td>
            <td>
              网络权限、应用基本信息（APP名称、包名、版本号）、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
                target="_blank"
                >《华为隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>魅族推送</td>
            <td>
              珠海市魅族通讯设备有限公司及其关联方（简称魅族）、与魅族建立合作的合作方公司
            </td>
            <td>推送消息</td>
            <td>
              网络权限、设备标识符（通过相关标识符生成不关联用户的PUSH_ID)；设备信息（型号、系统、版本类型、网络状态、应用信息、系统语言）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://www.meizu.com/privacy-policy" target="_blank"
                >《魅族隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>支付宝支付</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>支付宝付款</td>
            <td>
              Android
              ID、OAID、AAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
              地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi
              列表、传感器列表
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://opendocs.alipay.com/common/02kiq3"
                target="_blank"
                >《支付宝隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>微信OpenSDK</td>
            <td>深圳市腾讯计算机系统有限公司、财付通支付科技有限公司</td>
            <td>微信账号登录；APP内容分享到微信好友、朋友圈；微信支付</td>
            <td>
              网络权限、读写储存权限、MAC地址、唯一设备识别码、设备信息（设备类型、操作系统）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8#__section1"
                target="_blank"
                >《微信Open SDK个人信息处理规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>QQ</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>QQ钱包支付；APP内容分享到QQ好友、QQ空间</td>
            <td>
              网络权限、读写储存权限、主动提供的信息（昵称、手机号码、头像、图片）、设备信息（日志信息、位置信息）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://privacy.qq.com/policy/tencent-privacypolicy/"
                target="_blank"
                >《QQ隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>微博开放平台</td>
            <td>北京微梦创科网络技术有限公司</td>
            <td>APP内容分享到微博</td>
            <td>网络权限、读写储存权限、获取手机信息权限</td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://m.weibo.cn/c/privacy" target="_blank"
                >《微博个人信息保护政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>阿里云存储(OSS)</td>
            <td>阿里云计算有限公司</td>
            <td>保存作品图片、保存用户头像数据</td>
            <td>
              设备信息（设备型号、操作系统版本、设备设置、唯一设备标识符、软硬件特征信息、IP地址、日志信息）、网络权限、读写储存权限、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201710161525_98396.html"
                target="_blank"
                >《阿里云法律声明及隐私权政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯云慧眼人脸核身SDK</td>
            <td>腾讯云计算（北京）有限责任公司</td>
            <td>用于实人实名认证</td>
            <td>
              网络权限、相机使用权限、
              身份证信息（姓名、身份证号码）、人脸视频和照片、光线传感器信息
              、设备信息 （设备型号、操作系统）、Android
              端：OAID、iOS端：运营商信息、IDFV
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2"
                target="_blank"
                >《腾讯云慧眼人脸核身SDK隐私保护指引》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯云通信</td>
            <td>腾讯云计算（北京）有限责任公司</td>
            <td>即时通信</td>
            <td>
              网络权限、读写储存权限、麦克风、相机、获取手机信息权限、网络连接状态
              、设备型号、系统版本
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://cloud.tencent.com/document/product/269/58094"
                target="_blank"
                >《IM SDK 隐私保护指引》</a
              >
            </td>
          </tr>
          <tr>
            <td>联通一键登录</td>
            <td>中国联合网络通信有限公司</td>
            <td>一键登录</td>
            <td>
              设备信息（网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商）、网络权限、获取手机信息权限、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html"
                target="_blank"
                >《联通统一认证服务条款》</a
              >
            </td>
          </tr>
          <tr>
            <td>移动一键登录</td>
            <td>中移互联网有限公司</td>
            <td>一键登录</td>
            <td>
              设备信息（网络类型、ip地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商）,网络权限、读写储存权限、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://wap.cmpassport.com/resources/html/contract.html"
                target="_blank"
                >《移动统一认证服务条款》</a
              >
            </td>
          </tr>
          <tr>
            <td>电信一键登录</td>
            <td>世纪龙信息网络有限责任公司</td>
            <td>一键登录</td>
            <td>
              设备信息（网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商），网络权限、获取手机信息权限、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://e.189.cn/sdk/agreement/content.do?type=main&amp;appKey=&amp;hidetop=true&amp;returnUrl="
                target="_blank"
                >《天翼账号服务协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>国家网络身份认证</td>
            <td>公安部网络安全保卫局</td>
            <td>登录</td>
            <td>
              网络权限、相机权限、麦克风权限存储权限、设备标识信息（Android_ID）、设备及系统信息（设备品牌、设备型号、时区及时间）
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://cdnrefresh.ctdidcii.cn/w1/WHClient_H5/pages/secret.html"
                target="_blank"
                >《国家网络身份认证隐私协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>数美SDK</td>
            <td>北京数美时代科技有限公司</td>
            <td>账户与设备风险保护</td>
            <td>
              设备信息（包括设备品牌、设备制造商、设备型号、设备名称、设备系统类型及版本信息、设备基本设置、设备环境）、网络信息（包括网络的接入形式、周边WIFI列表、网络运营商信息、网络连接状态）、读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://www.ishumei.com/legal/cn/privacy.html"
                target="_blank"
                >《数美科技隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>Bugly SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>本SDK运行时对发生的的故障问题进行排查、分析、解决</td>
            <td>
              设备信息（包括设备品牌、设备制造商、设备型号、设备名称、设备系统类型及版本信息、设备基本设置、设备环境）、网络信息（包括网络的接入形式、周边WIFI列表、网络运营商信息、网络连接状态）、读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                target="_blank"
                >《Bugly SDK个人信息保护规则》</a
              >
            </td>
          </tr>
          <tr>
            <td>网易易盾</td>
            <td>杭州网易智企科技有限公司</td>
            <td>获取OAID</td>
            <td>
              设备信息：设备唯一识别码（设备序列号、OAID、IDFV、AAID）、设备品牌、设备名称、设备型号及设备系统类型、详细设置及版本信息；网络信息：设备IP地址、网络运营商信息、网络连接类型及状态、路由器标识（BSSID、SSID、MAC）；读取存储（相册、媒体和其他文件）权限、设备序列号、设备传感器信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://support.dun.163.com/documents/413846598587424768?docId=507376333387018240"
                target="_blank"
                >《网易易盾隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>百度网盘开放云盘</td>
            <td>北京度友科技有限公司</td>
            <td>登录百度账号，备份草稿/笔刷/色卡到云盘</td>
            <td>
              设备信息（硬件型号、操作系统版本及系统情况、设备配置、国际移动设备身份码IMEI、国际移动用户识别码IMSI、网络设备硬件地址MAC、供应商标识符IDFV、移动设备识别码MEID、匿名设备标识符OAID
              、集成电路卡识别码ICCID 、Android
              ID、硬件序列号）、网络信息（电信运营商、WIFI信息）、读取存储权限、设备传感器信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://pan.baidu.com/union/protocol/hl56pr0w6"
                target="_blank"
                >《百度网盘开放平台用户隐私协议》</a
              >
            </td>
          </tr>
          <tr>
            <td>BeiZi SDK</td>
            <td>上海倍孜网络技术有限公司</td>
            <td>推送程序化广告</td>
            <td>
              设备/网络/系统信息（设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、sim卡状态、传感器信息、掠过手势内容）、网络权限、设备标识符（Android:Android
              ID、OAID、GAID，iOS:IDFV、IDFA）、IP地址、设备传感器信息、运营商信息
            </td>
            <td>SDK自行采集</td>
            <td>
              <a
                href="https://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy"
                target="_blank"
                >《BeiZi隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯图灵盾SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>实名认证</td>
            <td>硬件序列号、网络状态、系统设置、系统属性、设备型号、操作系统、IP地址、运营商信息，Android：OAID、IMEI、IMSI、Android ID，iOS：IDFA、IDFV</td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://privacy.qq.com/document/preview/5331f064a91a47eb93993fdacb91c8f7" target="_blank"
                >《腾讯图灵盾风险识别SDK隐私政策》</a
              >
            </td>
          </tr>
          <tr>
            <td>minidns</td>
            <td>开源SDK</td>
            <td>检测当前设备dns数据，判断网络连接状态</td>
            <td>网络信息，IP地址，dns信息</td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://github.com/MiniDNS/minidns" target="_blank"
                >《链接》</a
              >
            </td>
          </tr>
          <tr>
            <td>xCrash SDK</td>
            <td>开源SDK</td>
            <td>收集应用崩溃信息</td>
            <td>获取应用进程列表</td>
            <td>SDK自行采集</td>
            <td>
              <a href="https://github.com/iqiyi/xCrash" target="_blank"
                >《链接》</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformationSharingList",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.information_sharing_list {
  .container {
    font-size: 14px;
    h1 {
      font-size: 24px;
    }
    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }
    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .third-url-list {
      > a {
        display: block;
      }
    }
    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;
        + ol {
          margin-top: 15px;
        }
      }
      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
    }
  }
  p {
    margin-top: 1em;
    margin-bottom: 0;
    line-height: 2;
  }
  a {
    // display: block;
    word-break: break-all;
    color: #1989fa;
    text-decoration: none;
  }
  .sdk-table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
        &:first-child,
        &:last-child {
          width: 80px;
        }
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>
